import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FreeNavbar from "ui/free/FreeNavbar";
import AnimationBody from "./AnimationBody";
import AnimationRightBar from "./AnimationRightBar";
import styles from "./AnimationRoot.module.scss";

const AnimationRoot: React.FC = () => {
    return (
        <>
            <FreeNavbar />
            <Container className={styles.container}>
                <Row>
                    <Col sm={4}>
                        <AnimationRightBar />
                    </Col>
                    <Col sm={8}>
                        <AnimationBody />
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default AnimationRoot;
